import debounce from 'lodash/debounce';
import { useEffect } from 'react';

const DEBOUNCE_TIME = 300;

export function useOnWindowResize(callback: () => void, debounceTime: number = DEBOUNCE_TIME) {
    useEffect(() => {
        const debouncedCallback = debounce(callback, debounceTime);
        window.addEventListener('resize', debouncedCallback);

        return () => {
            window.removeEventListener('resize', debouncedCallback);
        };
    }, [callback, debounceTime]);
}
